import React from "react";
import { Link } from "react-router-dom";
import { PAYMENT_EMAIL, TIKTOK_URL, TIKTOK_HANDLE } from "@/lib/brand";
import TikTokIcon from "@/components/TikTokIcon";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-800 bg-slate-950 mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <img
            src="/brand/logo-red.png"
            alt="Washed Up Trainers"
            className="h-20 w-auto mb-4 opacity-90"
            data-testid="footer-logo"
          />
          <div className="text-[10px] tracking-[0.25em] text-yellow-400 font-mono uppercase mb-1">
            Washed Up Trainers
          </div>
          <h3 className="text-white font-black font-[Outfit] text-2xl mb-2">
            BUY · SELL · <span className="text-yellow-400">TRADE</span>
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed">
            Alberta&apos;s Pokémon TCG vendors. Sealed product, singles &amp;
            slabs — plus trades, wishlists and local shows across the province.
          </p>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-tiktok-link"
            className="mt-4 inline-flex items-center gap-2 bg-slate-900 border border-yellow-400/40 text-yellow-400 hover:bg-slate-800 px-4 py-2 rounded-md text-sm font-bold font-mono uppercase tracking-wider transition-colors"
          >
            <TikTokIcon className="w-4 h-4" />
            @{TIKTOK_HANDLE}
          </a>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-mono mb-3">
            Pages
          </h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/shop" className="hover:text-yellow-400">Shop</Link></li>
            <li><Link to="/buy" className="hover:text-yellow-400">Sell your cards</Link></li>
            <li><Link to="/trade" className="hover:text-yellow-400">Trade</Link></li>
            <li><Link to="/request-cards" className="hover:text-yellow-400">Request cards</Link></li>
            <li><Link to="/shows" className="hover:text-yellow-400">Shows</Link></li>
            <li><Link to="/shipping" className="hover:text-yellow-400">Shipping &amp; pickup</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-mono mb-3">
            Payments
          </h4>
          <p className="text-sm text-slate-300 leading-relaxed">
            Interac e-Transfer or PayPal. Flat $15 CAD tracked shipping, or free
            local pickup at any show in Alberta.
          </p>
          <div className="mt-3 text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">
            Send payment to
          </div>
          <code
            data-testid="footer-payment-email"
            className="mt-1 block bg-slate-900 border border-slate-800 rounded px-3 py-2 text-yellow-400 text-xs font-mono break-all"
          >
            {PAYMENT_EMAIL}
          </code>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500 font-mono">
        © {new Date().getFullYear()} Washed Up Trainers — Alberta, Canada
        <span className="mx-2 opacity-40">·</span>
        <Link
          to="/login"
          data-testid="footer-staff-link"
          className="text-slate-600 hover:text-slate-400 transition-colors"
        >
          Staff
        </Link>
      </div>
    </footer>
  );
}
